import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";

import { consultationQKeys } from "@hooks/queries/consultation/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";


interface MutationProps {
  consultationId: string;
  patientId: string;
}

export const useArchiveConsultation = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: ({ consultationId }: MutationProps) => {
      return api.delete(`report/archive/${consultationId}`);
    },
    onSuccess: (_, variables) => {
      // console.log(res.data)
      queryClient.invalidateQueries({
        queryKey: consultationQKeys.patient(variables.patientId),
      });
    },

    onError: (res: any) => {
      console.error("[From Archive Consultation]", res);

      handleErrors(res, "mutation");
    },
  });
};
